import React from 'react'

const LittieCheckCircle = ({ className = '', color = '#151F31' }) => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_250_3432)">
        <path
          d="M6 11.75C4.60761 11.75 3.27226 11.1969 2.28769 10.2123C1.30312 9.22774 0.75 7.89239 0.75 6.5C0.75 5.10761 1.30312 3.77226 2.28769 2.78769C3.27226 1.80312 4.60761 1.25 6 1.25C7.39239 1.25 8.72774 1.80312 9.71231 2.78769C10.6969 3.77226 11.25 5.10761 11.25 6.5C11.25 7.89239 10.6969 9.22774 9.71231 10.2123C8.72774 11.1969 7.39239 11.75 6 11.75ZM6 12.5C7.5913 12.5 9.11742 11.8679 10.2426 10.7426C11.3679 9.61742 12 8.0913 12 6.5C12 4.9087 11.3679 3.38258 10.2426 2.25736C9.11742 1.13214 7.5913 0.5 6 0.5C4.4087 0.5 2.88258 1.13214 1.75736 2.25736C0.632141 3.38258 0 4.9087 0 6.5C0 8.0913 0.632141 9.61742 1.75736 10.7426C2.88258 11.8679 4.4087 12.5 6 12.5Z"
          fill={color}
        />
        <path
          d="M8.22727 4.22753C8.22192 4.2327 8.21691 4.23822 8.21227 4.24403L5.60752 7.56278L4.03777 5.99228C3.93113 5.89292 3.7901 5.83883 3.64437 5.8414C3.49865 5.84397 3.35961 5.903 3.25655 6.00606C3.15349 6.10912 3.09446 6.24816 3.09188 6.39389C3.08931 6.53961 3.14341 6.68065 3.24277 6.78728L5.22727 8.77253C5.28073 8.82589 5.34439 8.86794 5.41445 8.89617C5.48452 8.9244 5.55955 8.93822 5.63507 8.93682C5.7106 8.93542 5.78507 8.91883 5.85404 8.88802C5.92301 8.85722 5.98507 8.81284 6.03652 8.75753L9.03052 5.01503C9.13246 4.90803 9.1882 4.7652 9.18568 4.61743C9.18317 4.46966 9.12259 4.32881 9.01706 4.22535C8.91152 4.12188 8.76951 4.06411 8.62171 4.06452C8.47392 4.06492 8.33223 4.12348 8.22727 4.22753Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_250_3432">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default LittieCheckCircle
